import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { fetchAuthSession } from 'aws-amplify/auth';
import { StockageService } from '../stockage/stockage.service';

@Injectable({
  providedIn: 'root',
})
export class HttpHeadersService {
  constructor(private readonly stockageService: StockageService) {}

  public async getHeaders(): Promise<HttpHeaders> {
    let headers = new HttpHeaders();
    const { tokens } = await fetchAuthSession();
    if (tokens?.idToken) {
      headers = headers.set('Authorization', tokens?.idToken.toString());
    }

    return headers;
  }

  public async getHeadersWithPervalContext(): Promise<HttpHeaders> {
    let headers = new HttpHeaders();
    // put session tokens in header if they're not null
    const { tokens } = await fetchAuthSession();
    const X_Perval_Context = this.stockageService.getItem('X-Perval-Context');
    if (tokens?.idToken) {
      headers = headers.set('X-Perval-Auth', tokens?.idToken.toString());
      headers = headers.set('Authorization', tokens?.idToken.toString());
    }
    if (X_Perval_Context) {
      headers = headers.set('X-Perval-Context', X_Perval_Context);
    }
    return headers;
  }
}
